import { automount } from "./helpers/automount";

// auto mount all `.react-component` elements
automount();
